import { Order } from 'effect'
import type { RaceEvent } from './RaceEvent'

export type LightningBoostType = 'common' | 'rare' | 'epic' | 'legendary'

export interface Race {
  uuid: string
  createdAt: string
  round: number
  raceConfigurationId: string
  raceEvents: RaceEvent[]
  // Lightning Round fields
  isLightningRound: boolean
  lightningBoostType: LightningBoostType | null
  lightningBoostPercent: number | null
  lightningBoostedItems: string[] | null
}

export const orderRacesByCreatedAt = Order.mapInput(
  Order.reverse(Order.string),
  (race: Race) => race.createdAt
)
